import promptReducer from './reducers'

export const FETCH_PROMPTS = 'marvel/prompts/FETCH_PROMPTS'
export const CLEAR_PROMPTS = 'marvel/prompts/CLEAR_PROMPTS'
export const FETCH_PROMPTS_POST_ORDER =
  'marvel/prompts/FETCH_PROMPTS_POST_ORDER'

export type PromptState = ReturnType<typeof promptReducer>
